import { ShieldExclamationIcon } from "@heroicons/vue/24/outline";
import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from "@headlessui/vue";
import { isShowQuestionDialog } from "@/utils";
export default {
  name: "HeaderTerms",
  components: {
    ShieldExclamationIcon,
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle
  },
  data: () => ({
    isDialogOpen: false
  }),
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      if (isShowQuestionDialog()) {
        return;
      }
      this.isDialogOpen = false;
    }
  }
};